<template>
  <div class="alerts-block" :class="{ confirm: isConfirm }" v-if="alerts.length > 0">
    <Alert
      v-for="alert in alerts"
      :key="alert.id"
      :id="alert.id"
      :message="alert.message"
      :isGlobal="true"
      :color="alert.color"
      :duration="alert.duration"
      @closed="onClosed(alert, $event)"
    />
  </div>
</template>

<script>
import Alert from "./Alert.vue";
import { mapState, mapActions } from "vuex";
import { AUTH_CLOSE_SERVER_ALERT } from "@/store/actions/auth";

export default {
  name: "AlertManager",
  components: { Alert },
  computed: {
    ...mapState("alerts", ["alerts"]),
    isConfirm() {
      return this.alerts.every((alert) => alert.type === "confirm");
    },
  },
  methods: {
    ...mapActions("alerts", ["removeAlert"]),
    ...mapActions([AUTH_CLOSE_SERVER_ALERT]),
    onClosed(alert, payload) {
      if (alert && alert.is_server && payload && payload.fromUser) {
        this.AUTH_CLOSE_SERVER_ALERT(alert.id);
      }
      this.removeAlert({ id: alert.id });
    },
  },
};
</script>
